import { render } from "./CallUs.vue?vue&type=template&id=567c95b0&scoped=true"
import script from "./CallUs.vue?vue&type=script&lang=js"
export * from "./CallUs.vue?vue&type=script&lang=js"

import "./CallUs.vue?vue&type=style&index=0&id=567c95b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567c95b0"]])

export default __exports__